import { Box, Flex, Text } from '@chakra-ui/react';
import { Banner, Button } from '@morressier/alembic';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Loading from '../Status/Loading';
import { fetchWorkspaceMembership } from 'src/api/queries';
import { useKeycloak } from 'src/components/AuthHOC';
import { useBrandConfig } from 'src/contexts/BrandConfigProvider';
import { APPLICATION_NAME } from 'src/constants';

export const AcceptWorkspaceInvitation = () => {
  const { currentUser } = useKeycloak();
  const location = useLocation();
  const navigate = useNavigate();
  const { authContent, BrandLayout } = useBrandConfig();

  const membershipId = new URLSearchParams(location.search).get('membershipId');

  const { data: membership, isLoading } = useQuery({
    queryKey: ['workspace-membership', { membershipId }],
    queryFn: () =>
      membershipId ? fetchWorkspaceMembership(membershipId) : null
  });

  if (isLoading) return <Loading />;

  if (!membership) {
    navigate('/app/account');
    return <></>;
  }

  const isInvitationValidForUser = membership.userId === currentUser.id;

  const {
    workspace: { shortname: workspace },
    organization: { name: organization }
  } = membership;

  return (
    <BrandLayout>
      <Flex flexDirection={'column'} gap={2}>
        {!isInvitationValidForUser ? (
          <Flex flexDirection={'column'} gap={8}>
            <Banner
              heading="The invitation is not valid for this user!"
              variant="attention"
              content={
                <Text>
                  Please login via the email address associated with the
                  invitation.
                </Text>
              }
            />
            {authContent.Provider}
          </Flex>
        ) : (
          <>
            <Text textStyle={'headingTitle'}>Welcome to {APPLICATION_NAME}!</Text>
            <Text>
              As an Editor in the {organization} workspace, you can now:
            </Text>
            <Box marginStart={2}>
              <ul>
                <li>Screen submissions with saved/reusable filters</li>
                <li>Review details like deadlines, notes, and activity logs</li>
                <li>Make decisions and invite peer reviewers</li>
              </ul>
            </Box>
            <Text>Thank you for your time and expertise!</Text>
            <Flex gap={2} marginTop={4}>
              <Button
                variant={'primary'}
                onClick={() =>
                  navigate(`/app/workspace/${workspace}/submissions`)
                }
              >
                View All Submissions
              </Button>
            </Flex>
          </>
        )}
      </Flex>
    </BrandLayout>
  );
};
